import { render, staticRenderFns } from "./CreateWorkplaceSupervisor.vue?vue&type=template&id=47c3731c&"
import script from "./CreateWorkplaceSupervisor.vue?vue&type=script&lang=js&"
export * from "./CreateWorkplaceSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports